"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListBox = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const autocomplete_selector_styles_1 = require("./autocomplete-selector.styles");
const generic_1 = require("../../generic");
const localization_1 = require("../../../localization");
exports.ListBox = react_1.default.forwardRef((_a, ref) => {
    var { children, moreItemsLoading, onSave, onCancel } = _a, props = __rest(_a, ["children", "moreItemsLoading", "onSave", "onCancel"]);
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(autocomplete_selector_styles_1.StyledMenuList, Object.assign({ ref: ref }, props), children, moreItemsLoading && react_1.default.createElement(generic_1.LoadingIndicator, { className: "load-more-indicator" })), onSave || onCancel ? (react_1.default.createElement(autocomplete_selector_styles_1.StyledListBoxActionsWrapper, null, onCancel && react_1.default.createElement(ui_components_1.Button, { onMouseDown: () => onCancel(), title: t({ key: 'CANCEL' }), variant: "text", rounded: true, color: "primary" }), onSave && react_1.default.createElement(ui_components_1.Button, { onMouseDown: () => onSave(), title: t({ key: 'APPLY' }), rounded: true, color: "primary", variant: "contained" }))) : null));
});
exports.ListBox.displayName = 'ListBox';
exports.default = exports.ListBox;
